module.exports = new __parcel__URL__("multiple-channel-light.44b4e478.svg").toString();